import React, { Component } from 'react';
import classNames from 'classnames';
import Paging from './common/Paging.react.js';
let i18n = require("i18next");

export default class NotificationCenter extends Component {
    render() {
        return (
            <div id="notifications" className="state hidden">
                <div className="nav head">
                    <span>消息中心</span>
                    <span className="badge" style={{display:this.props.unreadMessage>0?"inlineBlock":"none"}}>{this.props.unreadMessage}</span>
                </div>
                <div className="body">
                    <div className="palette">
                        <img className="selected-all" src={require("../images/notifications/uncheckRead.png")}/>
                        <span className="action">主题</span>
                        <span className="action">
                            <div className="drop-action"><span>标记为<img className="mark-notice" src={require("../images/notifications/dropdown.png")}/></span></div>
                            <div className="mark-dropdown hidden">
                                <div className="state-read" data-status="Read"><img src={require("../images/notifications/uncheckRead.png")}/>已读</div>
                                <div className="state-unread" data-status="Unread"><img src={require("../images/notifications/uncheckedUnread.png")}/>未读</div>
                            </div>
                        </span>
                        <span className="action delete-message">删除</span>
                    </div>
                    <div className="notifications">
                        <ul className="notice-ul">
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/react/NotificationCenter.react.js